import React from "react";
import Slider from "react-slick";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface SlickCarouselProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  slidesToShow?: number;
  slidesToScroll?: number;
  responsive?: any[];
}

function SamplePrevArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left: -30,
        zIndex: 1,
        cursor: "pointer",
        fontSize: 18,
        color: "#333",
      }}
      onClick={onClick}
    >
      <LeftOutlined />
    </div>
  );
}

function SampleNextArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: -30,
        zIndex: 1,
        cursor: "pointer",
        fontSize: 18,
        color: "#333",
      }}
      onClick={onClick}
    >
      <RightOutlined />
    </div>
  );
}

export function SlickCarousel<T>({
  items,
  renderItem,
  slidesToShow = 3,
  slidesToScroll = 1,
  responsive = [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 600, settings: { slidesToShow: 1 } },
  ],
}: SlickCarouselProps<T>) {
  const settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 400,
    slidesToShow,
    slidesToScroll,
    swipeToSlide: true,
    responsive,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
  };

  return (
    <Slider {...settings}>
      {items.map((item, index) => (
        <div key={index} style={{ padding: 8 }}>
          {renderItem(item, index)}
        </div>
      ))}
    </Slider>
  );
}
